import { render, staticRenderFns } from "./PointCreditError.vue?vue&type=template&id=bf36f16e"
import script from "./PointCreditError.vue?vue&type=script&lang=js"
export * from "./PointCreditError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports